/* eslint-disable react-hooks/exhaustive-deps */
import { JSX, Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";

import SectionSkeleton from "@/components/helpers/Section/Section.skeleton.tsx";
import MainCollectionsSection from "@/components/main/MainCollectionsSection";
import MainGenresSection from "@/components/main/MainGenresSection";
import MainHistorySection from "@/components/main/MainHistorySection";

import { ROUTES } from "@/config/routes.ts";
import { useGetProfileDetail } from "@/hooks/api/user.hooks";
import { useIsKids } from "@/hooks/useIsKids";
import useModalRouter from "@/hooks/useModalRouter";

import { MODAL_ROUTES } from "../modals/router/ModalRoutes";
import MainActorsSection from "./MainActorsSection";
import MainCategoriesSection from "./MainCategoriesSection";
import MainDistributors from "./MainDistributors";
import MainMoviesCollectionSection from "./MainMoviesCollectionSection";
import MainPremiersSection from "./MainPremiersSection";
import MainTvSection from "./MainTvSection";
import RecommendationSection from "./RecommendationSection";

const CheckProfileInfo = ({ profileId }: { profileId: number }) => {
  const { data } = useGetProfileDetail(profileId);
  const { openModal, currentModal } = useModalRouter();

  useEffect(() => {
    if (data) {
      if (currentModal == MODAL_ROUTES.PROFILE_INFO) return;

      if ((!data.date_of_birth || !data.gender) && !currentModal) {
        openModal(MODAL_ROUTES.PROFILE_INFO, { profile_id: profileId.toString() });
      }
    }
  }, [data, currentModal]);

  return <></>;
};

const MainList = (): JSX.Element => {
  const { t } = useTranslation();
  const token = localStorage.getItem("splay:access");
  const profile = localStorage.getItem("splay:profileId");
  const isKids = useIsKids();

  return (
    <>
      <Suspense fallback={<SectionSkeleton type={"distributor"} title={""} link={ROUTES.HISTORY} />}>
        <MainDistributors />
      </Suspense>
      {token && (
        <Suspense>
          <MainHistorySection />
        </Suspense>
      )}
      <Suspense
        fallback={<SectionSkeleton type={"channels"} title={t("General.tv-channels")} link={ROUTES.CHANNELS.MAIN} />}
      >
        <MainTvSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
        <MainPremiersSection />
      </Suspense>
      {!isKids && (
        <Suspense
          fallback={<SectionSkeleton type={"collection"} title={t("recently-watched")} link={ROUTES.HISTORY} />}
        >
          <MainGenresSection />
        </Suspense>
      )}
      {!isKids && token && profile && (
        <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
          <RecommendationSection />
        </Suspense>
      )}
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
        <MainMoviesCollectionSection from={0} to={1} />
      </Suspense>

      <Suspense fallback={<SectionSkeleton type={"collection"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
        <MainCollectionsSection />
      </Suspense>
      <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
        <MainMoviesCollectionSection from={1} to={2} />
      </Suspense>
      {!isKids && (
        <Suspense
          fallback={<SectionSkeleton type={"channels"} title={t("General.tv-channels")} link={ROUTES.PERSONS.MAIN} />}
        >
          <MainActorsSection />
        </Suspense>
      )}
      {!isKids && (
        <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
          <MainMoviesCollectionSection from={2} to={13} />
        </Suspense>
      )}

      {isKids && (
        <Suspense fallback={<SectionSkeleton type={"content"} title={t("recently-watched")} link={ROUTES.HISTORY} />}>
          <MainCategoriesSection />
        </Suspense>
      )}
      {profile && token && <CheckProfileInfo profileId={+profile} />}
    </>
  );
};

export default MainList;
